import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const API_URL = 'https://admin.lumetiq.in/api';
const IMAGE_URL = 'https://admin.lumetiq.in/';
const DEFAULT_IMAGE = '/assets/img/project/project-details.jpg';

const ProductDetailsSingle = ({ id, onProjectName }) => {
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [nextProductId, setNextProductId] = useState(null);
  const [prevProductId, setPrevProductId] = useState(null);

  useEffect(() => {
    if (project && project.name) {
      onProjectName(project.name);
    }

    const fetchProjectDetails = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetch(`${API_URL}/products/read_single.php?id=${id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setProject(data);
        if (data && data.name) {
          onProjectName(data.name);
        }
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    const fetchAdjacentProducts = async () => {
      try {
        const response = await fetch(`${API_URL}/products/read.php`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        const products = data.records;

        console.log("products",products);

        const currentIndex = products.findIndex(product => String(product.id) === String(id));

        const prevIndex = currentIndex > 0 ? currentIndex - 1 : null;
        const nextIndex = currentIndex < products.length - 1 ? currentIndex + 1 : null;

        setPrevProductId(prevIndex !== null ? products[prevIndex].id : null);
        setNextProductId(nextIndex !== null ? products[nextIndex].id : null);
      } catch (error) {
        console.error("Failed to fetch adjacent products:", error);
        setPrevProductId(null);
        setNextProductId(null);
      }
    };

    if (id) {
      fetchProjectDetails();
      fetchAdjacentProducts();
      console.log("project",project);
    }
  }, [id, onProjectName]);

  const handleWhatsAppInquiry = () => {
    const message = `Hello, I am interested in the product: ${project.name}. Could you provide more details?`;
    const whatsappNumber = '9574100028';
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, '_blank');
  };

  const goToPrevious = () => {
    if (prevProductId) {
      navigate(`/Product-details/${prevProductId}`);
    }
  };

  const goToNext = () => {
    if (nextProductId) {
      navigate(`/Product-details/${nextProductId}`);
    }
  };

  if (loading) {
    return (
      <div className="pj-detials-page pt-110 pb-140">
        <div className="container">
          <div className="text-center">Loading...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pj-detials-page pt-110 pb-140">
        <div className="container">
          <div className="text-center text-danger">Error: {error}</div>
        </div>
      </div>
    );
  }

  if (!project) {
    return (
      <div className="pj-detials-page pt-110 pb-140">
        <div className="container">
          <div className="text-center">Project not found</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="pj-detials-page pt-110 pb-140">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="pj-details-hero-img w-img p-relative">
                {project.images && project.images.length > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      gap: "10px",
                      justifyContent: "center",
                    }}
                  >
                    {project.images.map((image, index) => (
                      <img
                        key={index}
                        src={image.path ? `${IMAGE_URL}/${image.path.replace(/^\//, '')}` : DEFAULT_IMAGE}
                        alt={project.name || "Project Image"}
                        style={{
                          width: "100%",
                          maxWidth: "600px",
                          height: "auto",
                          maxHeight: "800px",
                          objectFit: "cover",
                          margin: "5px",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = DEFAULT_IMAGE;
                        }}
                      />
                    ))}
                  </div>
                ) : (
                  <img
                    src={
                      project.image_path
                        ? `${IMAGE_URL}/${project.image_path.replace(/^\//, '')}`
                        : DEFAULT_IMAGE
                    }
                    alt={project.name || "Project Image"}
                    style={{
                      width: "100%",
                      maxWidth: "700px",
                      height: "auto",
                      maxHeight: "700px",
                      objectFit: "cover",
                      display: "block",
                      margin: "0 auto",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = DEFAULT_IMAGE;
                    }}
                  />
                )}

                
                <div className="pj-detials-contact pt-85">
                  <h3 className="pj-details-meta-title">{project.name}</h3>
                  <div className="pj-detials-meta-info" style={{display:'flex',flexDirection:'column'}}>
                    <span className="pl-15">
                      <b>Rated Speed:</b> {project.rated_speed || 'N/A'}
                    </span>
                    <span className="pl-15">
                      <b>Travel Height:</b>
                      <a href="#"> {project.travel_height || 'N/A'}</a>
                    </span>
                    <span className="pl-15">
                      <b>Rated Capacity:</b>
                      <a href="#"> {project.rated_capacity || 'N/A'}</a>
                    </span>
                    <span className="pl-15">
                      <b>Max Person:</b>
                      <a href="#"> {project.max_person || 'N/A'}</a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="pj-detials-contact pt-85">
                <h3 className="pj-detials-title">Details About Product</h3>
                <div dangerouslySetInnerHTML={{ __html: project.description || 'No description available.' }} />
                {project.content && (
                  <div dangerouslySetInnerHTML={{ __html: project.content }} />
                )}
              </div>

              <div className="text-center mb-reset mt-70 mb-140">
            <a href="#" onClick={handleWhatsAppInquiry}  className="tp-btn-border">
              Inquire Now
              <span>
                <svg
                  width="22"
                  height="8"
                  viewBox="0 0 22 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                    fill="currentColor"
                  ></path>
                </svg>
                <svg
                  width="22"
                  height="8"
                  viewBox="0 0 22 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </span>
            </a>
          </div>


          <div className="pj-detials-pagenation d-flex justify-content-between pt-45">
  <div className="pj-detials-pagenation-left">
    {prevProductId ? (
      <a href="#" onClick={goToPrevious} className="pj-prev-btn">
        &larr; B a c k
      </a>
    ) : (
      <span>&larr; Back</span>
    )}
  </div>

  <div className="pj-detials-pagenation-right">
    {nextProductId ? (
      <a href="#" onClick={goToNext} className="pj-next-btn">
        N e x t &rarr;
      </a>
    ) : (
      <span>Next &rarr;</span>
    )}
  </div>
</div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDetailsSingle;